module.exports = __webpack_public_path__ + "img/MZ-tab.db0adc12.jpg";